import React, { Component } from 'react';

type ErrorPageProps = {
    source: string,
    title: string,
    detail: string,
}

function ErrorPage({source, title, detail}: ErrorPageProps) {
    return (
        <div className="all-white">
            <div className="jumbotron all-white">
                <h2>{title}</h2>
                <p>{detail}</p>
            </div>
        </div>
    );
}

export { 
    ErrorPage
}